import React from 'react';
import { Phone, Mail, MapPin, Droplets, ShieldCheck, Sparkles } from 'lucide-react';
import { ScheduleForm } from '../components/ScheduleForm';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-teal-100 selection:text-teal-900" data-id="element-32">
      {/* Navigation / Header */}
      <nav className="w-full px-6 py-6 flex items-center justify-between max-w-5xl mx-auto" data-id="element-33">
        <div className="flex items-center gap-2" data-id="element-34">
          <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center shadow-lg shadow-teal-600/20" data-id="element-35">
            <Sparkles className="text-white w-6 h-6" data-id="element-36" />
          </div>
          <span className="font-bold text-xl tracking-tight text-slate-900" data-id="element-37">
            Curti-see{' '}
            <span className="font-normal text-slate-600" data-id="element-38">Window Cleaning</span>
          </span>
        </div>
        <a href="tel:2314200863" className="hidden md:flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-teal-600 transition-colors" data-id="element-39">
          <Phone className="w-4 h-4" data-id="element-40" />
          (231) 420-0863
        </a>
      </nav>

      <main data-id="element-41">
        {/* Hero Section */}
        <section className="px-6 pt-8 pb-20 md:pt-16 md:pb-32 max-w-5xl mx-auto" data-id="element-42">
          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-43">
            {/* Hero Content */}
            <div className="space-y-8 text-center md:text-left" data-id="element-44">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-bold uppercase tracking-wider" data-id="element-45">
                <span className="w-2 h-2 rounded-full bg-sky-500 animate-pulse" data-id="element-46"></span>
                Now serving Cheboygan Area
              </div>

              <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight leading-[1.1] text-slate-900" data-id="element-47">
                Courtesy you can <span className="text-teal-600" data-id="element-48">see</span>{' '}
                clearly.
              </h1>

              <p className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-md mx-auto md:mx-0" data-id="element-49">
                Professional window cleaning with a polite touch. We treat your
                home with the respect it deserves—and leave your windows
                invisible.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start text-sm font-medium text-slate-500" data-id="element-50">
                <div className="flex items-center gap-2" data-id="element-51">
                  <ShieldCheck className="w-5 h-5 text-teal-600" data-id="element-52" />
                  Fully Insured
                </div>
                <div className="hidden sm:block w-1 h-1 bg-slate-300 rounded-full" data-id="element-53"></div>
                <div className="flex items-center gap-2" data-id="element-54">
                  <Droplets className="w-5 h-5 text-teal-600" data-id="element-55" />
                  Eco-friendly Products
                </div>
              </div>
            </div>

            {/* Hero Form */}
            <div className="w-full max-w-md mx-auto md:ml-auto" data-id="element-56">
              <ScheduleForm data-id="element-57" />
            </div>
          </div>
        </section>

        {/* Features / Trust Section */}
        <section className="bg-white py-16 px-6 border-t border-slate-100" data-id="element-58">
          <div className="max-w-5xl mx-auto" data-id="element-59">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-60">
              <div className="p-6 rounded-2xl bg-slate-50 md:bg-transparent" data-id="element-61">
                <div className="w-12 h-12 bg-sky-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-sky-600" data-id="element-62">
                  <Sparkles className="w-6 h-6" data-id="element-63" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-64">Streak-Free Shine</h3>
                <p className="text-slate-600 text-sm" data-id="element-65">
                  We use purified water and professional squeegees for a perfect
                  finish every time.
                </p>
              </div>

              <div className="p-6 rounded-2xl bg-slate-50 md:bg-transparent" data-id="element-66">
                <div className="w-12 h-12 bg-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-teal-600" data-id="element-67">
                  <ShieldCheck className="w-6 h-6" data-id="element-68" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-69">Respectful Service</h3>
                <p className="text-slate-600 text-sm" data-id="element-70">
                  We wear shoe covers, use drop cloths, and treat your home like
                  our own.
                </p>
              </div>

              <div className="p-6 rounded-2xl bg-slate-50 md:bg-transparent" data-id="element-71">
                <div className="w-12 h-12 bg-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-indigo-600" data-id="element-72">
                  <Droplets className="w-6 h-6" data-id="element-73" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-74">Rain Guarantee</h3>
                <p className="text-slate-600 text-sm" data-id="element-75">
                  If it rains within 48 hours and ruins our work, we'll come
                  back and touch it up for free.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Referral Program Section */}
        <section className="py-20 px-6 bg-gradient-to-br from-teal-50 to-sky-50" data-id="element-76">
          <div className="max-w-4xl mx-auto text-center" data-id="element-77">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal-100 text-teal-700 text-sm font-bold uppercase tracking-wider mb-6" data-id="element-78">
              <Sparkles className="w-4 h-4" data-id="element-79" />
              Referral Rewards
            </div>

            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-80">
              Share the shine, save big
            </h2>
            <p className="text-lg text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-81">
              Love our service? Refer your friends and neighbors to earn amazing
              discounts on your next cleaning.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-82">
              {/* Tier 1 */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-slate-100 hover:border-teal-200 transition-all" data-id="element-83">
                <div className="text-5xl font-black text-teal-600 mb-3" data-id="element-84">
                  10%
                </div>
                <div className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-4" data-id="element-85">
                  Off Next Clean
                </div>
                <div className="text-3xl font-bold text-slate-900 mb-2" data-id="element-86">1</div>
                <div className="text-slate-600 text-sm" data-id="element-87">Referral</div>
              </div>

              {/* Tier 2 - Featured */}
              <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 shadow-xl border-2 border-teal-500 transform md:scale-105 relative" data-id="element-88">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-400 text-yellow-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-89">
                  POPULAR
                </div>
                <div className="text-5xl font-black text-white mb-3" data-id="element-90">50%</div>
                <div className="text-sm font-bold text-teal-100 uppercase tracking-wider mb-4" data-id="element-91">
                  Off Next Clean
                </div>
                <div className="text-3xl font-bold text-white mb-2" data-id="element-92">4</div>
                <div className="text-teal-100 text-sm" data-id="element-93">Referrals</div>
              </div>

              {/* Tier 3 */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-slate-100 hover:border-teal-200 transition-all" data-id="element-94">
                <div className="text-5xl font-black text-teal-600 mb-3" data-id="element-95">
                  FREE
                </div>
                <div className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-4" data-id="element-96">
                  Complete Clean
                </div>
                <div className="text-3xl font-bold text-slate-900 mb-2" data-id="element-97">8</div>
                <div className="text-slate-600 text-sm" data-id="element-98">Referrals</div>
              </div>
            </div>

            <p className="text-sm text-slate-500 mt-8" data-id="element-99">
              Your referrals must complete their first cleaning for you to earn
              rewards. No limit on how many times you can redeem!
            </p>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 text-slate-400 py-12 px-6" data-id="element-100">
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-start" data-id="element-101">
            <div data-id="element-102">
              <div className="flex items-center gap-2 mb-4" data-id="element-103">
                <Sparkles className="text-teal-500 w-6 h-6" data-id="element-104" />
                <span className="font-bold text-xl text-white" data-id="element-105">Curti-see</span>
              </div>
              <p className="max-w-xs text-sm leading-relaxed mb-6" data-id="element-106">
                Making Cheboygan brighter, one window at a time. Professional,
                polite, and perfectly clear.
              </p>
              <div className="flex gap-4" data-id="element-107">
                {/* Social placeholders */}
                <div className="w-8 h-8 bg-slate-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer" data-id="element-108"></div>
                <div className="w-8 h-8 bg-slate-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer" data-id="element-109"></div>
                <div className="w-8 h-8 bg-slate-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer" data-id="element-110"></div>
              </div>
            </div>

            <div className="space-y-4 md:text-right" data-id="element-111">
              <h4 className="text-white font-bold mb-4" data-id="element-112">Contact Us</h4>
              <a href="tel:2314200863" className="flex items-center gap-3 md:justify-end hover:text-white transition-colors" data-id="element-113">
                <Phone className="w-4 h-4" data-id="element-114" />
                (231) 420-0863
              </a>
              <a href="mailto:CurtiseyCleansllc@gmail.com" className="flex items-center gap-3 md:justify-end hover:text-white transition-colors" data-id="element-115">
                <Mail className="w-4 h-4" data-id="element-116" />
                CurtiseyCleansllc@gmail.com
              </a>
              <div className="flex items-center gap-3 md:justify-end" data-id="element-117">
                <MapPin className="w-4 h-4" data-id="element-118" />
                1504 East State Street, Cheboygan, MI 49721
              </div>
            </div>
          </div>
          <div className="max-w-5xl mx-auto mt-12 pt-8 border-t border-slate-800 text-xs text-center md:text-left flex flex-col md:flex-row justify-between gap-4" data-id="element-119">
            <p data-id="element-120">
              &copy; {new Date().getFullYear()} Curti-see Window Cleaning
              Service. All rights reserved.
            </p>
            <div className="flex gap-6 justify-center md:justify-end" data-id="element-121">
              <a href="#" className="hover:text-white" data-id="element-122">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white" data-id="element-123">
                Terms of Service
              </a>
            </div>
          </div>
        </footer>
      </main>
    </div>;
}